import { useState } from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import copyUrl from 'modules/marketplace/components/utils/copyUrl'

type SharingAreaProps = {
  moduleTitle: string
  moduleUrl: string
}

const SharingArea = ({ moduleTitle, moduleUrl }: SharingAreaProps) => {
  const [isSaved, setIsSaved] = useState(false)

  return (
    <Box alignItems="flexStart" justifyContent="flexStart">
      <Box paddingBottom="s8">
        <Text size="400" weight="medium" color="grey1000">
          {i18n.t('marketplace.modules.sharing_area.title')}
        </Text>
      </Box>
      <Text size="300" color="grey800">
        {i18n.t('marketplace.modules.sharing_area.description', {
          module_name: moduleTitle,
        })}
      </Text>
      <Box width="full" paddingTop="s12">
        <Button
          onClick={() => copyUrl(setIsSaved, moduleUrl)}
          type="secondary"
          disabled={isSaved}
          iconName={isSaved ? 'check' : 'link'}
        >
          {isSaved
            ? i18n.t('marketplace.modules.sharing_area.copied')
            : i18n.t('marketplace.modules.sharing_area.copy')}
        </Button>
      </Box>
    </Box>
  )
}

export default SharingArea
